<template>
  <div>
    <vx-breadcrumb :list="breadcrumbList" class="custom-bread-crumb" />
    <vs-card>
      <vs-table
        max-items="5"
        pagination
        :data="ticketTask || []"
        :description="false"
        search
      >
        <template slot="header">
          <div style="margin-right: auto; font-size: 1.5rem; font-weight: 550">
            {{ $t("Ticket Task List") }}
          </div>
          <span class="vx-col order-1">
            <vs-button
              icon-pack="feather"
              icon="icon-plus"
              @click="
                $router.push({
                  name: 'Create Ticket Task',
                  params: { ticketId: $route.params.ticketId },
                })
              "
              size="small"
              >{{ $t("Create Ticket Task") }}</vs-button
            >
          </span>
        </template>
        <template slot="thead">
          <vs-th>{{ $t("customers.label.id") }}</vs-th>
          <vs-th>{{ $t("customers.label.priority") }}</vs-th>
          <vs-th>{{ $t("customers.label.created_date") }}</vs-th>
          <vs-th>{{ $t("customers.label.created_time") }}</vs-th>
          <vs-th>{{ $t("customers.label.assign_to") }}</vs-th>
          <vs-th>{{ $t("customers.label.last_comment") }}</vs-th>
          <vs-th>{{ $t("customers.label.status") }}</vs-th>
          <vs-th class="tHeadCenter">{{ $t("customers.label.action") }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="index" :data="ticket" v-for="(ticket, index) in data">
            <vs-td :data="ticket.id">{{ ticket.id }}</vs-td>

            <vs-td :data="ticket.priority">
              <span :style="{ color: priorityColor(ticket.priority) }">
                {{ ticket.priority }}
              </span>
            </vs-td>
            <vs-td :data="ticket.createdDate">{{
              getDate(ticket.createdDate)
            }}</vs-td>
            <vs-td :data="ticket.createdDate">{{
              getTime(ticket.createdDate)
            }}</vs-td>

            <vs-td>{{ ticket.assignedTo }}</vs-td>

            <vs-td :data="ticket.comments">{{ ticket.comments }}</vs-td>

            <vs-td :data="ticket.status">
              <span :style="{ color: statusColor(ticket.status) }">
                {{ ticket.status }}
              </span>
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <div class="container_img">
                <feather-icon
                  title="Edit Ticket Task"
                  @click.stop="editTicketTask(ticket)"
                  icon="EditIcon"
                  class="icon_row"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current orange_icon"
                />
                <feather-icon
                  v-if="ticket.status !== 'COMPLETED'"
                  title="Complete Task"
                  @click.stop="removeTicket(ticket.taskId)"
                  icon="XIcon"
                  class="icon_row"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                />
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>

    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.close_ticket')"
        :active.sync="cancelTicketPopup"
        class="popup-close mid-popup"
      >
        <form ref="form">
          <div class="vx-col w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("customers.label.status")
                }}<span class="required"> *</span></small
              >
              <v-select
                :options="cancelStatus"
                :placeholder="$t('placeholder.label.SelectOne')"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="cancelObj.status"
                class="min-w-200 w-full mb-2"
              />
            </div>
          </div>
          <div class="vx-col sm:w-full">
            <div class="dropdown-with-label">
              <small class="date-label"
                >{{ $t("customers.label.Resolution")
                }}<span class="required"> *</span></small
              >
              <vs-textarea
                class="w-full textbox"
                v-model="cancelObj.resolution"
                hint="Please provide as much detail as possible so we can best assist you."
              />
            </div>
          </div>
          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button
                @click="cancelTicket"
                class="footerButton-next mt-4 mb-4"
                style="top: 0px"
                >{{ $t("customers.label.submit") }}</vs-button
              >
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import moment from "moment";
import vSelect from "vue-select";
import { quillEditor } from "vue-quill-editor";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const ticketObj = {
  dueTime: null,
  assignedTo: null,
  priority: null,
  sourceOfTicket: null,
  problemCode: null,
  subCategory: null,
  description: null,
  teamCode: "",
  status: "OPEN",
  title: "",
  type: "Customer",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: moment().format("DD MMMM YYYY"),
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: null,
};

export default {
  props: ["clientId", "refresh"],
  emits: ["openTicket"],
  data() {
    return {
      breadcrumbList: [
        { name: "Customers", path: "/customers" },
        {
          name: "View Customer",
          path: `/customers/view_customer/${this.$route.params.id}`,
        },
        {
          name: "Ticket Task",
        },
      ],
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      ticketId: "",
      taskId: "",
      ticketCreatePopup: false,
      cancelTicketPopup: false,
      cancelStatus: ["PENDING", "COMPLETED"],
      ticket: { ...ticketObj },
      bulkUploads: {
        file: null,
      },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i",
      },
      teamUsersItem: [{ id: null, username: "all" }],
      cancelObj: {
        status: "",
        resolution: "",
        // ticketURL: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
      },
      viewTicketPopup: false,
      reopenTicketPopup: false,
      reopenComment: "",
    };
  },
  components: {
    Datepicker,
    flatPickr,
    quillEditor,
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    template() {
      return this.$store.getters["customer/getTicketTemplate"];
    },
    ...mapState({
      teamUsers: (state) => state.customer.teamUsers,
      ticketById: (state) => state.customerTicket.ticketById,
      ticketViewById: (state) => state.customerTicket.ticketViewById,
      formattedDate: (state) => state.settings.selectedDateFormat,
      ticketTask: (state) => state.customerTicket.ticketTask,
    }),
  },
  methods: {
    editTicketTask(ticket) {
      this.$router.push({
        name: "Edit Ticket Task",
        params: { subTaskId: ticket.id, ticketId: this.$route.params.ticketId },
      });
    },
    priorityColor(priority) {
      let color = "";
      switch (priority.toUpperCase()) {
        case "HIGH":
          color = "red";
          break;
        case "MEDIUM":
          color = "#FFC107";
          break;
        case "LOW":
          color = "blue";
          break;
        default:
          color = "grey";
      }
      return color;
    },
    statusColor(status) {
      let color = "";
      switch (status.toUpperCase()) {
        case "OPEN":
          color = "blue";
          break;
        case "CLOSED":
          color = "red";
          break;
        case "WORKING":
          color = "orange";
          break;
        case "REOPEN":
          color = "orange";
          break;
        default:
          color = "black";
      }
      return color;
    },
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    getTime(time) {
      const t = new Date(time);
      return moment(t, "HH:mm:ss").format("HH:mm:ss");
    },
    async getTicketTask() {
      try {
        await this.$store.dispatch(
          "customerTicket/setClientTicketTask",
          this.$route.params.ticketId
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async cancelTicket() {
      try {
        await this.$store.dispatch("customerTicket/cancelSubTaskTicketAction", {
          taskId: this.taskId,
          data: this.cancelObj,
        });
        this.cancelTicketPopup = false;
        this.getTicketTask();
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Ticket Closed Successfully!",
          type: "success",
        });
      } catch (error) {
        this.cancelTicketPopup = false;
        this.$swal({
          title: "Error",
          icon: "error",
          text: "Something went wrong!",
          type: "error",
        });
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async removeTicket(taskId) {
      this.taskId = taskId;
      this.cancelTicketPopup = true;

      try {
        // this.getTicketTask();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  async mounted() {
    await this.getTicketTask();
  },
  watch: {
    ticketCreatePopup(newValue) {
      if (newValue) {
        this.ticket.ticketDate = moment().format("dd MMMM yyyy HH:mm:ss a");
      }
    },
    "ticket.problemCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getSubCategory(this.ticket.problemCode);
      }
    },
    "ticket.teamCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getTeamUsers(this.ticket.teamCode);
      }
    },
    "ticket.dueTime"() {
      debugger;
    },
    // refresh() {
    //   this.getTicketTask();
    // },
  },
};
</script>
<style lang="scss" scoped>
.detail-text {
  font-size: 0.8rem;
  .vx-row > .vx-col {
    padding: 0 0.2rem;
  }
}
.action-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
.priority-status.vs-chip-primary {
  background: #b5dafb !important;
  border: 1px solid #3c6bec;
  color: #3c6bec !important;
}
.priority-status.vs-chip-warning {
  background: #fdf6db !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.priority-status.vs-chip-danger {
  background: #ffc2c2 !important;
  border: 1px solid #ff0000;
  color: #ff0000 !important;
}
.priority-status.vs-chip-orange {
  background: #fbd9b5 !important;
  border: 1px solid #ff8914;
  color: #ff8914 !important;
}
</style>
